<template>
  <CTabs variant="tabs" class="nav-tabs-boxed">
    <CTab title="Restrições de Venda">
      <crud-base
        :url="url"
        :columns="columns"
        :onDelete="() => {}"
        :onUpdate="() => {}"
        :onStore="() => {}"
        :enableSearch="true"
        :formInputs="formInputs"
        :checkAlerts="true"
        primaryKey="id"
      />
    </CTab>
  </CTabs>
</template>

<script>
import CrudBase from "../../components/crud/CrudBase";
import {
  schemaBooleanSelect,
  schemaMoney,
  schemaSelect,
  schemaTextArea,
  schemaTextField,
} from "@/helpers/form";
import { yesNoRepresentation } from "@/helpers/transformers";

export default {
  name: "restricao-venda",
  components: {
    CrudBase,
  },
  data() {
    return {
      url: "/admin/restricoes-venda",
      columns: [
        { label: "ID", field: "id", sortable: true },
        { label: "ATIVO", field: "ativo", sortable: true, representedAs: (row) => yesNoRepresentation(row.ativo) },
        { label: "TIPO VALIDAÇÃO", field: "tipo_validacao", sortable: true },
        { label: "MOTIVO", field: "motivo", sortable: false },
        { label: "CALL CENTER", field: "aplicacallcenter", sortable: false, representedAs: (row) => yesNoRepresentation(row.aplicacallcenter) },
        { label: "FORÇA VENDAS", field: "aplicafv", sortable: false, representedAs: (row) => yesNoRepresentation(row.aplicafv) },
        { label: "B2B", field: "aplicab2b", sortable: false, representedAs: (row) => yesNoRepresentation(row.aplicab2b) },
      ],
      formInputs: {
        id: schemaTextField('ID', true, 2),
        ativo: schemaBooleanSelect('Ativo', true, 2, 1),
        tipo_validacao: schemaSelect('Tipo Validação', true, 4, {
          'ENVIO_PEDIDO': 'Envio Pedido',
          'CHECKOUT': 'Checkout',
          'CARGA': 'Carga',
        }),
        motivo: schemaTextArea('Motivo', false, 12),

        // Origem do Pedido
        aplicacallcenter: schemaBooleanSelect('Aplica Call Center?', true, 4, 0),
        aplicafv: schemaBooleanSelect('Aplica Força Vendas?', true, 4, 0),
        aplicab2b: schemaBooleanSelect('Aplica B2B?', true, 4, 0),

        // Cliente
        cliente_id: schemaTextField('Cliente ID', false, 4),
        filial_id: schemaTextField('Filial ID', false, 4),
        regiao_id: schemaTextField('Região ID', false, 4),
        praca_id: schemaTextField('Praça ID', false, 4),
        rede_id: schemaTextField('Rede ID', false, 4),
        atividade_id: schemaTextField('Atividade ID', false, 4),
        representante_id: schemaTextField('Representante ID', false, 4),
        supervisor_id: schemaTextField('Supervisor ID', false, 4),
        tipo_documento: schemaTextField('Tipo Documento', false, 4),
        tipo_frete: schemaTextField('Tipo Frete', false, 4),

        // Produto
        produto_id: schemaTextField('Produto ID', false, 4),
        produtoprincipal_id: schemaTextField('Produto Principal ID', false, 4),
        fornecedor_id: schemaTextField('Fornecedor ID', false, 4),
        dimensao1: schemaTextField('Dimensão 1', false, 4),
        dimensao2: schemaTextField('Dimensão 2', false, 4),
        dimensao3: schemaTextField('Dimensão 3', false, 4),
        dimensao4: schemaTextField('Dimensão 4', false, 4),
        dimensao5: schemaTextField('Dimensão 5', false, 4),
        dimensao6: schemaTextField('Dimensão 6', false, 4),
        dimensao7: schemaTextField('Dimensão 7', false, 4),
        dimensao8: schemaTextField('Dimensão 8', false, 4),
        dimensao9: schemaTextField('Dimensão 9', false, 4),
        dimensao10: schemaTextField('Dimensão 10', false, 4),

        // Condições Pagamento
        operacao_id: schemaTextField('Operação ID', false, 4),
        cobranca_id: schemaTextField('Cobrança ID', false, 4),
        planopagamento_id: schemaTextField('Plano Pagamento ID', false, 4),

        // Exceções
        valida_alvara: schemaBooleanSelect('Valida Alvará?', true, 4, 0),
        valor_minimo: schemaMoney('Valor Mínimo', false, 4),
      },
    };
  },
};
</script>
